namespace GeniuzPOS.Lookups {
    export interface VwBrandTypeRow {
        Id?: number;
        BrandTypeCode?: string;
        BrandTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IsActive?: number;
        FullName?: string;
    }

    export namespace VwBrandTypeRow {
        export const idProperty = 'BrandTypeCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwBrandType';
        export const lookupKey = 'Lookups.VwBrandType';

        export function getLookup(): Q.Lookup<VwBrandTypeRow> {
            return Q.getLookup<VwBrandTypeRow>('Lookups.VwBrandType');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            BrandTypeCode = "BrandTypeCode",
            BrandTypeName = "BrandTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IsActive = "IsActive",
            FullName = "FullName"
        }
    }
}
